/* Teno X – protected Männersache preview. The existing 276-product widget owns all product data. */
(function (win) {
  'use strict';
  if (new URL(win.location.href).searchParams.get('bereich') !== 'maennersache') return;
  const doc = win.document;
  const state = { status: 'waiting', mounted: false, active: false };
  win.LWSTenoMensPreviewAddon = state;

  function boot() {
    if (state.mounted) return true;
    const root = doc.querySelector('[data-lws-release][data-lws-entry-ready="true"][data-lws-entry-route="maennersache"]');
    const configNode = root?.querySelector('[data-lr-config-json]');
    if (!root || !configNode || win.__lwsMensSelection?.status !== 'mounted') return false;
    let config;
    try { config = JSON.parse(configNode.textContent); }
    catch { state.status = 'invalid-shop-config'; return true; }
    if (config.internal !== true) { state.status = 'internal-preview-required'; return true; }
    const widget = win.LWSTenoPreviewV2;
    if (widget?.version !== '2.0.0' || typeof widget.mount !== 'function') {
      state.status = 'teno-v2-not-available';
      return true;
    }
    const area = root.querySelector('[data-lws-entry-category="maennersache"]');
    const tabs = area?.querySelector('.lws-mens-segments');
    const pendant = tabs?.querySelector('[data-lws-mens-group="pendants"]');
    const suits = area?.querySelector('#lr-hochzeit');
    const jewelry = area?.querySelector('#lr-schmuck');
    const count = area?.querySelector('.lws-mens-selection-count');
    if (!tabs || !pendant || !suits || !jewelry || !count) return false;
    if (tabs.querySelector('[data-lws-mens-group="teno"]')) {
      state.status = 'duplicate-teno-button';
      return true;
    }

    const button = doc.createElement('button');
    button.type = 'button';
    button.className = 'lws-mens-segment';
    button.dataset.lwsMensGroup = 'teno';
    button.textContent = 'Teno';
    button.setAttribute('aria-pressed', 'false');
    button.setAttribute('aria-controls', 'lws-teno-mens-preview');
    pendant.after(button);

    const panel = doc.createElement('div');
    panel.id = 'lws-teno-mens-preview';
    panel.className = 'lws-mens-jewelry-panel';
    panel.hidden = true;
    jewelry.after(panel);

    function closeTenoDialog() {
      const dialog = panel.querySelector('.lws-tn-dialog');
      if (dialog?.open) dialog.close();
    }
    function showTeno() {
      if (!state.mountedWidget) {
        const result = widget.mount(panel, {
          internalPreview: true,
          initialCategory: 'herren-ringe',
          loadOriginalImages: true
        });
        if (result?.mounted !== true || result.cartAllowed !== false || result.cards !== 276) {
          panel.replaceChildren();
          panel.hidden = true;
          state.status = 'teno-widget-validation-failed';
          return;
        }
        state.mountedWidget = true;
      }
      suits.hidden = true;
      jewelry.hidden = true;
      count.hidden = true;
      panel.hidden = false;
      tabs.dataset.activeGroup = 'teno';
      for (const peer of tabs.querySelectorAll('[data-lws-mens-group]'))
        peer.setAttribute('aria-pressed', String(peer === button));
      state.active = true;
      state.status = 'mounted-preview';
    }
    button.addEventListener('click', showTeno);
    tabs.addEventListener('click', event => {
      const peer = event.target.closest('[data-lws-mens-group]');
      if (!peer || peer === button || !tabs.contains(peer)) return;
      closeTenoDialog();
      panel.hidden = true;
      button.setAttribute('aria-pressed', 'false');
      state.active = false;
    });
    state.mounted = true;
    state.status = 'ready';
    state.button = button;
    state.panel = panel;
    return true;
  }

  const observer = new win.MutationObserver(() => {
    if (boot()) observer.disconnect();
  });
  observer.observe(doc.documentElement, { childList: true, subtree: true });
  doc.addEventListener('lws:mens-selection-ready', () => { if (boot()) observer.disconnect(); }, { once: true });
  if (boot()) observer.disconnect();
})(window);
